<template>
  <div class="db">
    <a v-show="!perksAreVisible" class="is-table-bold b ttu is-navy pointer" @click="perksAreVisible = !perksAreVisible" title="More perks">More Info +</a>
    <a v-show="perksAreVisible" class="is-table-bold b ttu is-navy pointer" @click="perksAreVisible = !perksAreVisible" title="Hide perks">Hide Info -</a>
    <transition name="slide-fade-rev">
      <div v-show="perksAreVisible" class="">
        <slot name="info-content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        perksAreVisible: false
      }
    }

  }
</script>